import {
  DataDisputeItemStatusLabels,
  VerificationRequestStatusLabels,
} from '@clearverify/constants';

import {
  DataDisputeItemStatus,
  VerificationRequestStatus,
  VerificationRequestType,
  VerifierType,
} from 'src/api';

import { InboxFilterFormFields } from './types';
import {
  getDateCreatedFilter,
  getEmployeeFilter,
  getEmployerFilter,
  getPeoFilter,
  getStatusFilter,
  getVerificationRequestTypesFilter,
  getVerifierFilter,
  getVerifierTypeFilter,
} from './utils';

export const VERIFICATION_REQUEST_STATUSES = Object.values(VerificationRequestStatus);
export const DATA_DISPUTE_STATUSES = Object.values(DataDisputeItemStatus);
export const VERIFICATION_REQUEST_TYPES = Object.values(VerificationRequestType);
export const VERIFIER_TYPES = Object.values(VerifierType);

export const VERIFICATION_REQUEST_STATUS_OPTIONS = VERIFICATION_REQUEST_STATUSES.map(status => ({
  value: status,
  label: VerificationRequestStatusLabels[status],
}));

export const DATA_DISPUTE_STATUS_OPTIONS = DATA_DISPUTE_STATUSES.map(status => ({
  value: status,
  label: DataDisputeItemStatusLabels[status],
}));

export const VERIFIER_TYPE_OPTIONS = VERIFIER_TYPES.map(verifierType => ({
  value: verifierType,
  label: verifierType,
}));

export const INBOX_FILTER_FUNCTION_MAPPING = {
  [InboxFilterFormFields.statuses]: getStatusFilter,
  [InboxFilterFormFields.dateCreated]: getDateCreatedFilter,
  [InboxFilterFormFields.employer]: getEmployerFilter,
  [InboxFilterFormFields.employee]: getEmployeeFilter,
  [InboxFilterFormFields.verificationRequestTypes]: getVerificationRequestTypesFilter,
  [InboxFilterFormFields.verifier]: getVerifierFilter,
  [InboxFilterFormFields.verifierType]: getVerifierTypeFilter,
  [InboxFilterFormFields.peo]: getPeoFilter,
};
